import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe which filter insurance items which match
 * Usage:
 * value | insuranceFilter
 */
@Pipe({
	name: 'insuranceFilter',
	pure: false,
})

/** Insurance filter pipe class */
export class InsuranceFilterPipe implements PipeTransform {
	transform(items: any[], filter?: any): any {
		if (!items || !filter) {
			return items;
		}
		// filter items array, items which match and return true will be
		// kept, false will be filtered out
		return items.filter(item => item.status == filter.status && item.medicalGroup == filter.medicalGroup);
	}
}
